import React, { useEffect } from "react";
import styled from "styled-components";
import { Users } from "lucide-react";
import { useClientsStore } from "./use-clients-store";
import { StatsCards } from "./stats-cards";
import { ClientsFilters } from "./clients-filters";
import { ClientsTable } from "./clients-table";
import { ModalBlockClient } from "./modal-block-client";
import { ModalDeleteClient } from "./modal-delete-client";

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 24px;
`;

const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
`;

const PageTitle = styled.h1`
  font-size: 21px;
  font-weight: 700;
  color: #202020;
  margin: 0;
`;

const TotalBadge = styled.span`
  font-size: 12px;
  opacity: 0.75;
`;

export const AuthClientsPage: React.FC = () => {
  const { total, stats, filter, fetchClients, fetchStats } = useClientsStore();

  useEffect(() => {
    fetchClients();
    fetchStats();
  }, [fetchClients, fetchStats]);

  useEffect(() => {
    fetchClients();
  }, [filter.status, filter.page, filter.limit, filter.sort_by, filter.sort_order, fetchClients]);

  return (
    <PageContainer>
      <PageHeader>
        <Users size={24} color="#202020" />
        <PageTitle>
          Клиенты
          <TotalBadge> ({total})</TotalBadge>
        </PageTitle>
      </PageHeader>

      <StatsCards stats={stats} />
      <ClientsFilters />
      <ClientsTable />

      <ModalBlockClient />
      <ModalDeleteClient />
    </PageContainer>
  );
};
